
        var result = require("!!../../../../node_modules/css-loader/index.js!./events-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/components/events-list/events-list.component.css
// module id = 1416
// module chunks = 0